import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

import App from './App';
import { unregister } from './registerServiceWorker';
import store from './reduxStore';

import './styles/scss/index.css';

ReactDOM.render(
    <Provider store={store}>
        <IntlProvider locale="en">
            <App />
        </IntlProvider>
    </Provider>,
    document.getElementById('root')
);

unregister();
